var _path, _path2, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDontDisplayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.19126C24 9.19126 19.5 1 12 1C4.5 1 0 9.19126 0 9.19126C0 9.19126 4.5 17.3825 12 17.3825C19.5 17.3825 24 9.19126 24 9.19126ZM1.7595 9.19126C2.48477 8.0968 3.31896 7.07745 4.2495 6.14858C6.18 4.22885 8.82 2.48932 12 2.48932C15.18 2.48932 17.8185 4.22885 19.752 6.14858C20.6825 7.07745 21.5167 8.0968 22.242 9.19126C22.155 9.32083 22.059 9.46381 21.9495 9.62019C21.447 10.3351 20.7045 11.2882 19.752 12.2339C17.8185 14.1537 15.1785 15.8932 12 15.8932C8.82 15.8932 6.1815 14.1537 4.248 12.2339C3.31747 11.3051 2.48328 10.2857 1.758 9.19126H1.7595Z",
    fill: "#4B4B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.46784C11.0054 5.46784 10.0516 5.86011 9.34835 6.55837C8.64509 7.25662 8.25 8.20366 8.25 9.19114C8.25 10.1786 8.64509 11.1257 9.34835 11.8239C10.0516 12.5222 11.0054 12.9144 12 12.9144C12.9946 12.9144 13.9484 12.5222 14.6517 11.8239C15.3549 11.1257 15.75 10.1786 15.75 9.19114C15.75 8.20366 15.3549 7.25662 14.6517 6.55837C13.9484 5.86011 12.9946 5.46784 12 5.46784ZM6.75 9.19114C6.75 7.80866 7.30312 6.48281 8.28769 5.50526C9.27226 4.5277 10.6076 3.97852 12 3.97852C13.3924 3.97852 14.7277 4.5277 15.7123 5.50526C16.6969 6.48281 17.25 7.80866 17.25 9.19114C17.25 10.5736 16.6969 11.8995 15.7123 12.877C14.7277 13.8546 13.3924 14.4038 12 14.4038C10.6076 14.4038 9.27226 13.8546 8.28769 12.877C7.30312 11.8995 6.75 10.5736 6.75 9.19114Z",
    fill: "#4B4B4B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.53033,
    y1: 0.862248,
    x2: 21.5009,
    y2: 17.8328,
    stroke: "#4B4B4B",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDontDisplayIcon);
export default __webpack_public_path__ + "static/media/dont-display-icon.39d65cdf705592b79f7535e788b1cca1.svg";
export { ForwardRef as ReactComponent };